import { PartnerStatusEnum } from 'api/backofficeApiClient';

export const getPartnerStatusLabel = (status: PartnerStatusEnum) => {
  switch (status) {
    case PartnerStatusEnum.InvitationRequested:
      return 'Not Registered';

    case PartnerStatusEnum.ProfileCompleted:
      return 'Set Up for Payments';

    case PartnerStatusEnum.Registered:
      return 'Registered, Profile not Completed';

    case PartnerStatusEnum.PendingPartnership:
      return 'Pending partnership';

    default:
      return '';
  }
};

export const getPartnerStatusHint = (status: PartnerStatusEnum) => {
  switch (status) {
    case PartnerStatusEnum.InvitationRequested:
      return 'In order to share your profit with this partner, they should register and complete their profile in Back-Office. We have sent an email invite with a unique registration link on the email that you specified.';

    case PartnerStatusEnum.ProfileCompleted:
      return 'This partner provided us with all the required information to distribute their profit.';

    case PartnerStatusEnum.Registered:
      return 'This partner registered in Back-Office, but we need their profile information to be completed in order to distribute their profit.';

    case PartnerStatusEnum.PendingPartnership:
      return 'This partner registered in Backoffice, but they need to confirm the partnership using the link in the received email in order to distribute profit.';

    default:
      return '';
  }
};
